import React, { useState, useEffect } from "react";
import { TableContainer } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import storePlaceholder from "../assets/images/placeholders/p-store.png";
import { useSnackbar } from "react-simple-snackbar";
import {
  ImgUrl,
  ApiService,
  getUserType,
  isPermissionExist,
} from "../services";
import { StorefrontSharp } from "@material-ui/icons";
import GPagination from "../gComponents/gPagination";
import GPaginationSelect from "../gComponents/gPaginationSelectbox";
import {
  Table,
  TableBody,
  TableRow,
  TableRowData,
  TableHead,
  TableHeader,
} from "../styledComponents/tableStyle";
import GEmpty from "../gComponents/gEmpty";
import GTableShimmer from "../gComponents/gTableShimmer";
import TooltipComponent from "../gComponents/gTooltip";
import GButton from "../gComponents/gButton";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import GSelectbox from "../gComponents/gSelectbox";
import QueryWith from "../Query";
import useSettings from "../useSettings";
import useDataFactory from "../useDataFactory";
import Modal from "react-modal";
import StoreEditForm from "../forms/storeEditForm";
import GSwitch from "../gComponents/gSwitch";
import CreateDuplicateStore from "../forms/storeDuplicateCreateForm";
import GActions from "../gComponents/gActionsStyle";

const availabilityFilters = [
  {
    title: "Open Only",
    value: "1",
  },
  {
    title: "Closed Only",
    value: "0",
  },
];

export default function Stores() {
  const [openSnackbar] = useSnackbar();
  const [storesData, setStoreData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [storePaginationData, setStorePaginationData] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [blockDialogOpen, setBlockDialogOpen] = useState(false);
  const [acceptDialogOpen, setAcceptDialogOpen] = useState(false);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [selectedStatusType, setSelectedStatusType] = useState();
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [selectedStoreData, setSelectedStoreData] = useState("");
  const [sevisible, setSevisible] = useState(false);
  const [showStoreDupilcateForm, setShowStoreDupilcateForm] = useState(false);
  const settings = useSettings(true);
  let history = useHistory();
  let params = new URLSearchParams(history.location.search);
  const [filters, setFilters] = useState({
    page: params.get("page") ? params.get("page") : "1",
    store_status: params.get("store_status") ? params.get("store_status") : "",
    branch_id: params.get("branch_id") ? params.get("branch_id") : "",
    status: params.get("status") ? params.get("status") : "active",
  });
  const { data: branchesData } = useDataFactory("branches", false);

  let statusFilters = [
    {
      title: "Active Stores",
      value: "0",
    },
    {
      title: "Blocked Stores",
      value: "1",
    },
  ];
  if (settings.signup_vendor == true) {
    statusFilters.push({
      title: "Pending Approval",
      value: "2",
    });
  }

  const columns = [
    { id: "id", label: "Id", minWidth: 30 },
    { id: "title", label: "Title", minWidth: 100 },
    { id: "address", label: "Address", minWidth: 180 },
    { id: "photo", label: "Photo", minWidth: 70, type: "image" },
    { id: "manager", label: "Store Manager", minWidth: 120, align: "center" },
    {
      id: "wallet_points_value",
      label: "Balance",
      minWidth: 100,
      align: "center",
      format: (value) => value.toFixed(2),
    },
    { id: "status", label: "Availability", minWidth: 60, align: "right" },
    {
      id: "created_at_formatted",
      label: "Created",
      minWidth: 150,
      align: "center",
    },
    getUserType() == true ||
    isPermissionExist("store_store") ||
    isPermissionExist("store_update") ||
    isPermissionExist("store_destroy")
      ? { id: "actions", label: "Actions", minWidth: 60, align: "right" }
      : "",
  ];

  const getStores = () => {
    var params = QueryWith(history.location, filters);
    if (params.length > 0) {
      history.push({
        pathname: "/stores",
        state: "store",
        search: params[0],
      });
    }
    ApiService({ method: "GET", route: "stores", body: filters })
      .then((response) => {
        console.log("gh" + response);
        if (response.data.status_code === 1) {
          setStoreData(response.data.data.data);
          setStorePaginationData(response.data.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getStores();
  }, [filters]);

  function addDefaultLogo(e) {
    e.target.src = storePlaceholder;
  }

  const deleteStore = () => {
    ApiService({ method: "DELETE", route: "stores/" + selectedStoreId })
      .then((response) => {
        console.log("gh" + JSON.stringify(response));
        if (response.data.status_code === 1) {
          getStores();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const blockStore = () => {
    var hitUrl =
      selectedStatusType === "Block"
        ? "store/block/" + selectedStoreId
        : "store/unblock/" + selectedStoreId;
    ApiService({ method: "POST", route: hitUrl })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          getStores();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangePage = (pageUrl) => {
    var NewPageNo = pageUrl.substr(pageUrl.lastIndexOf("=") + 1);
    setFilters({ ...filters, page: NewPageNo });
  };

  const handleToggleStatus = (newVal, id, ind) => {
    ApiService({
      method: "PUT",
      route: "stores/" + id,
      body: {
        store_status: newVal,
      },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          storesData[ind].store_status = newVal;
          setStoreData([...storesData]);
        } else {
          getStores();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const acceptRejectRequestedStore = (action) => {
    ApiService({ method: "POST", route: `store/${action}/${selectedStoreId}` })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          getStores();
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="mainInnerView">
      <h1>
        <StorefrontSharp /> Stores
      </h1>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <GSelectbox
          showSelectOption={false}
          defaultvalue={filters.status}
          data={statusFilters}
          id="s_status_filter"
          option_key="title"
          option_value="value"
          onChange={(newVal) => {
            setFilters({ ...filters, status: newVal, page: 1 });
          }}
          style={{
            border: "1px solid #e2e2e2",
            height: "40px",
            minWidth: "150px",
          }}
        />
        <GSelectbox
          placeholder="All Available"
          defaultvalue={filters.store_status}
          data={availabilityFilters}
          id="store_status_filter"
          option_key="title"
          option_value="value"
          onChange={(newVal) => {
            setFilters({ ...filters, store_status: newVal, page: 1 });
          }}
          style={{
            border: "1px solid #e2e2e2",
            height: "40px",
            minWidth: "150px",
          }}
        />
        {getUserType() ? (
          <GSelectbox
            placeholder="All Branches"
            defaultvalue={filters.branch_id}
            data={branchesData}
            id="store_branch_filter"
            option_key="title"
            option_value="id"
            onChange={(newVal) => {
              setFilters({ ...filters, branch_id: newVal, page: 1 });
            }}
            style={{
              border: "1px solid #e2e2e2",
              height: "40px",
              minWidth: "150px",
            }}
          />
        ) : (
          ""
        )}

        {storesData.length > 0 && (
          <React.Fragment>
            <GPagination
              style={{ marginLeft: "auto" }}
              count={storePaginationData.total}
              from={storePaginationData.from}
              to={storePaginationData.to}
              onChangeNextPage={() =>
                handleChangePage(storePaginationData.next_page_url)
              }
              onChangePrevPage={() =>
                handleChangePage(storePaginationData.prev_page_url)
              }
              rowsPerPage={storePaginationData.per_page}
              prevDisabled={storePaginationData.prev_page_url ? false : true}
              nextDisabled={storePaginationData.next_page_url ? false : true}
            ></GPagination>
            <GPaginationSelect
              defaultvalue={filters.page}
              totalPage={storePaginationData.last_page}
              onChangePage={(NewPageNo) =>
                setFilters({ ...filters, page: NewPageNo })
              }
            />
          </React.Fragment>
        )}
      </div>

      <div className="listPaper" style={{ marginTop: "15px" }}>
        {isLoading === true ? (
          <GTableShimmer></GTableShimmer>
        ) : (
          <TableContainer>
            {storesData.length === 0 ? (
              <GEmpty></GEmpty>
            ) : (
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns
                      .filter((c) => {
                        if (
                          getUserType() == true ||
                          isPermissionExist("store_destroy")
                        ) {
                          return c;
                        } else {
                          return c.id !== "actions";
                        }
                      })
                      .map((column) => (
                        <TableHeader
                          key={column.id}
                          style={{
                            minWidth: column.minWidth,
                            textAlign: column.align,
                          }}
                        >
                          {column.label}
                        </TableHeader>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {storesData.map((s, i) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={s.id}>
                        <TableRowData>#{s.id}</TableRowData>
                        <TableRowData>
                          <Link
                            to={{
                              pathname: "/store/" + s.id + "/orders",
                              state: "store",
                            }}
                          >
                            {s.title}
                          </Link>
                        </TableRowData>
                        <TableRowData>{s.address}</TableRowData>
                        <TableRowData>
                          <img
                            alt={s.title}
                            src={ImgUrl("store") + "/" + s.thumb_photo}
                            onError={addDefaultLogo}
                            style={{
                              height: "45px",
                              width: "45px",
                              borderRadius: "50%",
                            }}
                          />
                        </TableRowData>
                        <TableRowData
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {s.manager.title ? s.manager.title : "NA"}
                        </TableRowData>
                        <TableRowData
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {settings.currency_symbol + "" + s.balance}
                        </TableRowData>
                        <TableRowData
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {getUserType() ||
                          isPermissionExist("store_update") ? (
                            <GSwitch
                              id={"store" + s.id}
                              uId={s.id}
                              currentValue={s.store_status == 1 ? 1 : 0}
                              onSwitchChange={(newVal, id) =>
                                handleToggleStatus(newVal, id, i)
                              }
                              style={{ display: "inline-block" }}
                            />
                          ) : s.store_status == 1 ? (
                            "Yes"
                          ) : (
                            "No"
                          )}
                        </TableRowData>
                        <TableRowData
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {s.created}
                        </TableRowData>
                        {getUserType() == true ||
                        isPermissionExist("store_update") ||
                        isPermissionExist("store_destroy") ||
                        isPermissionExist("store_store") ? (
                          <TableRowData
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {s.status == 2 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                <GButton
                                  variant="condensed"
                                  onClick={(e) => {
                                    setSelectedStoreId(s.id);
                                    setAcceptDialogOpen(true);
                                  }}
                                  style={{
                                    padding: "0.4em 1em",
                                  }}
                                >
                                  Accept
                                </GButton>
                                <GButton
                                  variant="condensed"
                                  onClick={(e) => {
                                    setSelectedStoreId(s.id);
                                    setRejectDialogOpen(true);
                                  }}
                                  style={{ padding: "0.4em 1em" }}
                                >
                                  Reject
                                </GButton>
                              </div>
                            ) : (
                              <>
                                <GActions
                                  edit={
                                    getUserType() == true ||
                                    isPermissionExist("store_update")
                                      ? true
                                      : false
                                  }
                                  delete={
                                    getUserType() == true ||
                                    isPermissionExist("store_destroy")
                                      ? true
                                      : false
                                  }
                                  duplicate={
                                    getUserType() == true ||
                                    isPermissionExist("store_store")
                                      ? true
                                      : false
                                  }
                                  block={
                                    getUserType() == true && s.status === 0
                                      ? true
                                      : false
                                  }
                                  unblock={
                                    getUserType() == true && s.status === 1
                                      ? true
                                      : false
                                  }
                                  onEdit={() => {
                                    setSelectedStoreData(s);
                                    setSevisible(true);
                                  }}
                                  onDelete={() => {
                                    setSelectedStoreId(s.id);
                                    setDialogOpen(true);
                                  }}
                                  onDuplicate={() => {
                                    setSelectedStoreData(s);
                                    setShowStoreDupilcateForm(true);
                                  }}
                                  onBlock={() => {
                                    setSelectedStatusType("Block");
                                    setSelectedStoreId(s.id);
                                    setBlockDialogOpen(true);
                                  }}
                                  onUnblock={() => {
                                    setSelectedStatusType("Unblock");
                                    setSelectedStoreId(s.id);
                                    setBlockDialogOpen(true);
                                  }}
                                  style={{ verticalAlign: "middle" }}
                                  menuStyle={{ fontWeight: "400" }}
                                />
                              </>
                            )}
                          </TableRowData>
                        ) : (
                          ""
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}
      </div>
      {dialogOpen === true && (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Store"
          text="Are you sure you want to delete this store?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deleteStore();
          }}
        ></GConfirmDialog>
      )}

      {blockDialogOpen === true && (
        <GConfirmDialog
          open={blockDialogOpen}
          title={selectedStatusType + " Store"}
          text={
            "Are you sure you want to " + selectedStatusType + " this Store?"
          }
          handleClose={() => setBlockDialogOpen(false)}
          onConfirmClose={() => {
            setBlockDialogOpen(false);
            blockStore();
          }}
        ></GConfirmDialog>
      )}

      <Modal
        isOpen={sevisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setSevisible(false)}
        style={{
          content: {
            width: "480px",
          },
        }}
        contentLabel="Store Edit Form Modal"
      >
        <StoreEditForm
          sevisible={sevisible}
          setSevisible={setSevisible}
          data={selectedStoreData}
          onSubmit={getStores}
          settings={settings}
        />
      </Modal>

      <Modal
        isOpen={showStoreDupilcateForm}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setShowStoreDupilcateForm(false)}
        style={{
          content: {
            width: "480px",
          },
        }}
        contentLabel="Store Duplicate Create Form Modal"
      >
        <CreateDuplicateStore
          showStoreDupilcateForm={showStoreDupilcateForm}
          setShowStoreDupilcateForm={setShowStoreDupilcateForm}
          data={selectedStoreData}
          onSubmit={() => getStores()}
          settings={settings}
        />
      </Modal>

      {acceptDialogOpen === true && (
        <GConfirmDialog
          open={acceptDialogOpen}
          title={"Accept Signup Request"}
          text={"Are you sure you want to accept this Store signup request?"}
          handleClose={() => setAcceptDialogOpen(false)}
          onConfirmClose={() => {
            setAcceptDialogOpen(false);
            acceptRejectRequestedStore("approve");
          }}
        ></GConfirmDialog>
      )}
      {rejectDialogOpen === true && (
        <GConfirmDialog
          open={rejectDialogOpen}
          title={"Reject Signup Request"}
          text={"Are you sure you want to reject this Store signup request?"}
          handleClose={() => setRejectDialogOpen(false)}
          onConfirmClose={() => {
            setRejectDialogOpen(false);
            acceptRejectRequestedStore("reject");
          }}
        ></GConfirmDialog>
      )}
    </div>
  );
}
